import { type IAgentSetupResult, type IAgentSetupParam, IAddAgentTopInfo, IUpdateAgentConfig } from '../../../types/air-splitting/products/agentSetup';
import { EPaymentChannel, IAgentFeeItem, IProductUsageConfig } from '../../../types/common';
import { EAxiosResponseCode, getHttpErrorMessage, Http } from '@core/api';
import { getHostbaseUrl, isNull } from '@core/tools';

const hostUrl = getHostbaseUrl();

/**
 * 空中分账 - 分账产品 - 代理产品查询
 */
export async function queryProductSetupAgents(param: IAgentSetupParam) {
  let data = [] as IAgentSetupResult[];
  let total = 0;

  param = JSON.parse(JSON.stringify(param)) as IAgentSetupParam;
  try {
    const { code, context, message } = await Http.get<{data: IAgentSetupResult[]; total: number}>(`${hostUrl}/disburse/product-config/page`, param);

    if (code === EAxiosResponseCode.Succeed) {
      const { data: items, total: all } = context || {} as { data: IAgentSetupResult[]; total: number };

      data = items || [];
      total = Number(all) || 0;
    } else {
      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }

  return {
    data,
    total,
  };
}
/**
 * 空中分账 - 分账产品 - 代理产品 - 通道产品费率查询
 */
export async function queryProductUsageList(configId: number, isDetail = false, channelId?: EPaymentChannel) {
  let data = [] as IProductUsageConfig[];

  const parmas = {
    configId,
    channelId: isNull(channelId) ? undefined : channelId,
  };

  try {
    const { code, context, message } = await Http.get<IProductUsageConfig[]>(`${hostUrl}/disburse/product-usage-config/${isDetail ? 'detail' : 'cost-list'}`, parmas);

    if (code === EAxiosResponseCode.Succeed) {
      const items = context || [] as IProductUsageConfig[];

      data = items || [];
    } else {
      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }

  return data;
}

/**
 * 空中分账 - 分账产品 - 代理产品 - 更新通道产品费率
 */
export async function updateProductUsage(params: IUpdateAgentConfig) {
  try {
    const { code, message } = await Http.post(`${hostUrl}/disburse/product-usage-config/modify`, params);

    if (code !== EAxiosResponseCode.Succeed) {
      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }

}
/**
 * 空中分账 - 分账产品 - 代理商 根据代理商获取上级代理商信息
 */
export async function queryParentAgentInfo(agentId: number, channelId: EPaymentChannel) {
  let data = {} as IAddAgentTopInfo;

  try {
    const { code, context, message } = await Http.get<IAddAgentTopInfo>(`${hostUrl}/disburse/product-config/get-parent-agent-config`, {
      agentId,
      channelId,
    });

    if (code === EAxiosResponseCode.Succeed) {
      const items = context || {} as IAddAgentTopInfo;

      data = items || {} as IAddAgentTopInfo;
    } else {
      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }

  return data;
}

/**
 * 空中分账 - 分账产品 - 代理商配置 新增/编辑
 */
export async function saveProductSetupAgent(param: IAgentSetupResult, edit: boolean) {
  const action = edit ? 'update' : 'save';

  param = JSON.parse(JSON.stringify(param)) as IAgentSetupResult;

  const postParam = edit
    ? {
      configId: param.id,
      agentServiceRate: param.agentServiceRate,
    }
    : {
      agentName: param.agentName,
      agentId: param.agentId,
      parentAgentId: param.parent?.agentId,
      agentNo: param.agentNo,
      agentLevel: param.agentLevel,
      agentServiceRate: param.agentServiceRate ? Number(param.agentServiceRate) : undefined,
      channelId: param.channelId,
    };

  try {
    const { code, message } = await Http.post<IAgentSetupResult>(`${hostUrl}/disburse/product-config/${action}`, postParam);

    if (code !== EAxiosResponseCode.Succeed) {
      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }
}

/**
 * 空中分账 - 分账产品 - 代理商用户删除
 */
export async function deleteProductSetupAgent(configId: number) {
  try {
    const { code, message } = await Http.post<void>(`${hostUrl}/disburse/product-config/delete/${configId}`, {});

    if (code !== EAxiosResponseCode.Succeed) {
      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }
}

/**
 * 空中分账 - 分账产品 - 代理商用户 开启、关闭
 */
export async function changeUpperSetupAgents(configId: number, endabled: boolean) {
  const action = endabled ? 'enable' : 'disable';

  try {
    const { code, message } = await Http.post<void>(`${hostUrl}/disburse/product-config/${action}/${configId}`, {});

    if (code !== EAxiosResponseCode.Succeed) {
      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }
}

/**
 * 空中分账 - 分账产品 - 代理商费率查询
 */
export async function querySetupAgentFeeList(configId: number) {
  let data = [] as IAgentFeeItem[];

  try {
    const { code, context, message } = await Http.get<IAgentFeeItem[]>(`${hostUrl}/disburse/product-config/get-config-rate`, { configId });

    if (code === EAxiosResponseCode.Succeed) {

      data = context || [];
    } else {
      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }

  return data;
}

